import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';

import { colors, defaultTextStyle } from 'settings/theme';

const configuration = {
  title: {
    tag: 'h1',
    style: {
      fontSize: '3em',
      fontWeight: 'bold',
    },
  },
  heading1: {
    tag: 'h2',
    style: {
      fontSize: '2em',
      fontWeight: 'bold',
    },
  },
  heading2: {
    tag: 'h3',
    style: {
      fontSize: '1.5em',
      fontWeight: 'bold',
    },
  },
  heading3: {
    tag: 'h3',
    style: {
      fontSize: '1.5em',
      color: colors.textSecondary,
    },
  },
  caption: {
    tag: 'aside',
    style: {
      fontSize: '1em',
      color: colors.textSecondary,
    },
  },
  body: {
    tag: 'p',
    style: {
      fontSize: '1.2em',
    },
  },
  quote: {
    tag: 'blockquote',
    style: {
      fontFamily: 'Georgia',
      fontSize: '1.5em',
      fontStyle: 'italic',
      lineHeight: '1.66666em',
    },
  },
};

const validVariants = Object.keys(configuration);

function Typography(props) {
  const {
    variant,
    style,
    text,
    noWrap,
  } = props;

  if (!validVariants.includes(variant)) {
    throw new Error(`Invalid role. ${variant} was not found in ${validVariants}`);
  }

  const variantConfig = configuration[variant];

  const noWrapStyle = {
    whiteSpace: 'nowrap',
    overflowX: 'hidden',
    textOverflow: 'ellipses',
  };

  const mergedStyle = {
    margin: 0, // remove default styles for tags
    padding: 0,
    ...defaultTextStyle,
    ...variantConfig.style,
    ...(noWrap ? noWrapStyle : {}),
    ...style,
  };

  const Tag = variantConfig.tag;

  return (
    <Tag
      style={mergedStyle}
    >
      {text}
    </Tag>
  );
}

Typography.propTypes = {
  variant: PropTypes.oneOf(validVariants),
  style: StylePropType,
  text: PropTypes.string,
  noWrap: PropTypes.bool,
};

Typography.defaultProps = {
  variant: 'body',
  style: {},
  text: '',
  noWrap: false,
};

export default Typography;



// WEBPACK FOOTER //
// ./src/components/vistaprintUILibrary/Typography.js